import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#308E75', // Primary green
      light: '#62D3B0', // Secondary mint
      dark: '#1D5E4E',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#62D3B0', // Mint
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#D3410C', // Error red
      light: '#E1502F',
      dark: '#B32F09',
    },
    warning: {
      main: '#FFCF08', // Warning yellow
      light: '#FFDC48',
      dark: '#E6BA07',
    },
    success: {
      main: '#80A405', // Success green
      light: '#9DC21E',
      dark: '#6D8C04',
    },
    info: {
      main: '#1C5E99', // Info blue
      light: '#1799C1',
      dark: '#154A7A',
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1D1E1E', // Dark text
      secondary: '#757575',
    },
    grey: {
      300: '#D8D8D8', // Neutral light gray
    },
  },
  typography: {
    fontFamily: 'Montserrat, "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
    h1: {
      fontSize: '2rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '1.75rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h4: {
      fontSize: '1.25rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h5: {
      fontSize: '1.125rem',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    body1: {
      fontSize: '0.875rem', // 14px
      lineHeight: 1.4,
    },
    body2: {
      fontSize: '0.75rem', // 12px
      lineHeight: 1.4,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  spacing: 8, // Base spacing unit (8px)
  shape: {
    borderRadius: 4, // Default border radius
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
          padding: '8px 16px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '6px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
        },
      },
    },
  },
});

export default theme;

